exports.REGISTRY_ITEMS = {
	applications: Object.freeze({
		app_iprf: Object.freeze({
			id: "app_iprf",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/iprf/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/iprf/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieter/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_iprf"),
		}),
		app_iprf_directory: Object.freeze({
			id: "app_iprf_directory",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/iprf_directory/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/iprf_directory/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/makler", "/makler/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_iprf_directory"),
		}),
		app_conp_dashboardOld: Object.freeze({
			id: "app_conp_dashboardOld",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/conp_dashboardOld/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/meineimmobilien/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_conp_dashboardOld"),
		}),
		app_conp_documents: Object.freeze({
			id: "app_conp_documents",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/conp_documents/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/dokumente"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_conp_documents"),
		}),
		app_conp_estimationPage: Object.freeze({
			id: "app_conp_estimationPage",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/conp_estimationPage/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/meineschaetzungen/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_conp_estimationPage"),
		}),
		app_esfu_estimaLandingPage: Object.freeze({
			id: "app_esfu_estimaLandingPage",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_esfu_addressEntryPoint: Object.freeze({
					server: "https://www.immonet.de/assets/mfes/esfu_addressEntryPoint/v1/server/remoteEntry.js",
					client: "https://www.immonet.de/assets/mfes/esfu_addressEntryPoint/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/esfu_estimaLandingPage/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/esfu_estimaLandingPage/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/immobilienbewertung"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_esfu_estimaLandingPage"),
		}),
		app_fsbo_depositFunnelLandingFrboFlats: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFrboFlats",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/fsbo_depositFunnelLandingFrboFlats/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/fsbo_depositFunnelLandingFrboFlats/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/service/wohnungen-vermieten-wohnung-vermieten.html",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFrboFlats"),
		}),
		app_fsbo_depositFunnelLandingFsrboGeneric: Object.freeze({
			id: "app_fsbo_depositFunnelLandingFsrboGeneric",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/fsbo_depositFunnelLandingFsrboGeneric/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/fsbo_depositFunnelLandingFsrboGeneric/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/anbieten.html"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_fsbo_depositFunnelLandingFsrboGeneric"),
		}),
		app_pric: Object.freeze({
			id: "app_pric",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_avis_pricePagesAgencyCards: Object.freeze({
					client: "https://www.immonet.de/assets/mfes/avis_pricePagesAgencyCards/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/pric/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/pric/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/immobilienpreise/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_pric"),
		}),
		app_cmsg_inbox: Object.freeze({
			id: "app_cmsg_inbox",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/cmsg_inbox/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/inbox/*"]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_cmsg_inbox"),
		}),
		app_cldp: Object.freeze({
			id: "app_cldp",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_esfu_addressEntryPoint: Object.freeze({
					server: "https://www.immonet.de/assets/mfes/esfu_addressEntryPoint/v1/server/remoteEntry.js",
					client: "https://www.immonet.de/assets/mfes/esfu_addressEntryPoint/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/cldp/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/cldp/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/expose/:classifiedId",
					"/projekte/expose/:classifiedId",
					"/projekte/expose-preview/:classifiedId",
					"/wl-cdp/:classifiedId",
					"/cdp-preview/:classifiedId",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_cldp"),
		}),
		app_conp_seeker: Object.freeze({
			id: "app_conp_seeker",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/conp_seeker/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/meinbereich/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_conp_seeker"),
		}),
		app_home_main: Object.freeze({
			id: "app_home_main",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_avis_agencyInTheSpotlight: Object.freeze({
					client: "https://www.immonet.de/assets/mfes/avis_agencyInTheSpotlight/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/home_main/v2/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/home_main/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_home_main"),
		}),
		app_home_newbuilds: Object.freeze({
			id: "app_home_newbuilds",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/home_newbuilds/v2/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/home_newbuilds/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/neubauimmobilien.html"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_home_newbuilds"),
		}),
		app_hpfn_financingFunnel: Object.freeze({
			id: "app_hpfn_financingFunnel",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/hpfn_financingFunnel/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/hpfn_financingFunnel/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/immobilienfinanzierung-anfragen/*"]),
				type: "client",
			}),
			type: "application",
			version: 1,
			layout: "hidden",
			testing: Object.freeze([]),
			loader: async () => await import("app_hpfn_financingFunnel"),
		}),
		app_serp: Object.freeze({
			id: "app_serp",
			authorization: "any",
			microFrontends: Object.freeze({
				mfe_avis_adimsxl: Object.freeze({
					client: "https://www.immonet.de/assets/mfes/avis_adimsxl/v1/client/remoteEntry.js",
				}),
			}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/serp/v2/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/serp/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/1-zimmer-wohnung-kaufen.html",
					"/1-zimmer-wohnung-mieten.html",
					"/1-zimmer-wohnung.html",
					"/2-zimmer-wohnung-kaufen.html",
					"/2-zimmer-wohnung-mieten.html",
					"/2-zimmer-wohnung.html",
					"/3-zimmer-wohnung-kaufen.html",
					"/3-zimmer-wohnung-mieten.html",
					"/3-zimmer-wohnung.html",
					"/4-zimmer-wohnung-kaufen.html",
					"/4-zimmer-wohnung-mieten.html",
					"/4-zimmer-wohnung.html",
					"/5-zimmer-wohnung-kaufen.html",
					"/5-zimmer-wohnung-mieten.html",
					"/5-zimmer-wohnung.html",
					"/6-zimmer-wohnung-mieten.html",
					"/altbauwohnung.html",
					"/apartment.html",
					"/bauernhaus-kaufen.html",
					"/bauernhaus-mieten.html",
					"/bauernhof-kaufen.html",
					"/baugrundstuecke.html",
					"/behindertengerechte-wohnungen.html",
					"/besondere-immobilien.html",
					"/buero-praxis.html",
					"/bungalow-kaufen.html",
					"/city-immobilien.html",
					"/dachgeschosswohnung.html",
					"/dachterrassenwohnung.html",
					"/diskothek.html",
					"/doppelhaushaelfte-kaufen.html",
					"/doppelhaushaelfte-mieten.html",
					"/einfamilienhaus-kaufen.html",
					"/einfamilienhaus-mieten.html",
					"/erdgeschosswohnung-kaufen.html",
					"/erdgeschosswohnung-mieten.html",
					"/erdgeschosswohnung.html",
					"/etagenwohnung.html",
					"/finca-kaufen.html",
					"/freizeitgrundstueck.html",
					"/gastgewerbe-hotel.html",
					"/gastronomie.html",
					"/gewerbe.html",
					"/gewerbegrundstueck.html",
					"/gewerbeimmobilien.html",
					"/grundstueck-kaufen.html",
					"/grundstueck-mieten.html",
					"/grundstueck.html",
					"/guenstige-haeuser.html",
					"/guenstige-wohnung.html",
					"/halle-lager-produktion.html",
					"/haus-bauen.html",
					"/haus-kaufen.html",
					"/haus-mieten.html",
					"/haus-mit-garage-kaufen.html",
					"/haus-mit-garage-mieten.html",
					"/haus-mit-keller.html",
					"/haus-mit-pool.html",
					"/haus-mit-wintergarten.html",
					"/haus-von-privat-kaufen.html",
					"/herrenhaus.html",
					"/hochparterrewohnung.html",
					"/immobilien-kaufen.html",
					"/immobilien-mieten.html",
					"/immobilien-mit-garage.html",
					"/immobilien-mit-garten-kaufen.html",
					"/immobilien-mit-garten-mieten.html",
					"/immobilien-mit-garten.html",
					"/immobilien-privat-kaufen.html",
					"/immobilien-seniorengerecht.html",
					"/immobilien.html",
					"/industriehalle.html",
					"/kapitalanlage.html",
					"/kapitalanlagen-anlageimmobilien.html",
					"/laden-einzelhandel.html",
					"/landwirtschaft-forstwirtschaft.html",
					"/loft-studio-atelier-kaufen.html",
					"/loft-studio-atelier-mieten.html",
					"/loft-studio-atelier.html",
					"/luxushaus-kaufen.html",
					"/luxusimmobilien.html",
					"/luxuswohnung-kaufen.html",
					"/maisonette-kaufen.html",
					"/maisonette-mieten.html",
					"/maisonette.html",
					"/mehrfamilienhaus-kaufen.html",
					"/mehrfamilienhaus.html",
					"/moebliertes-haus.html",
					"/moebliertes-wohnen.html",
					"/moebliertes-zimmer.html",
					"/penthouse.html",
					"/reihenhaus-kaufen.html",
					"/reihenhaus-mieten.html",
					"/reihenhaus.html",
					"/reitanlage-gestuet.html",
					"/rustico-kaufen.html",
					"/schloss-kaufen.html",
					"/seniorenwohnungen-kaufen.html",
					"/seniorenwohnungen-mieten.html",
					"/seniorenwohnungen.html",
					"/single-wohnung.html",
					"/souterrainwohnung.html",
					"/sozialwohnung.html",
					"/stadthaus.html",
					"/stellplatz-garage-kaufen.html",
					"/stellplatz-garage-mieten.html",
					"/stellplatz-garage.html",
					"/studentenwohnung.html",
					"/tankstelle.html",
					"/teich-und-fischwirtschaft.html",
					"/tiefgaragenstellplatz.html",
					"/villa-kaufen.html",
					"/villa.html",
					"/wassergrundstueck.html",
					"/weingut-kaufen.html",
					"/werkstatt.html",
					"/wg.html",
					"/wohnung-bis-1000-euro.html",
					"/wohnung-bis-400-euro.html",
					"/wohnung-bis-500-euro.html",
					"/wohnung-bis-600-euro.html",
					"/wohnung-bis-800-euro.html",
					"/wohnung-kaufen.html",
					"/wohnung-mieten.html",
					"/wohnung-mit-balkon.html",
					"/wohnung-mit-einbaukueche.html",
					"/wohnung-mit-garten.html",
					"/wohnung-mit-terrasse.html",
					"/wohnung.html",
					"/zwangsversteigerung.html",
					"/zweifamilienhaus-kaufen.html",
					"/zweifamilienhaus-mieten.html",
					"/zweifamilienhaus.html",
					"/:legacyPrimaryLocation/:legacySecondaryLocation.html",
					"/classified-search",
					"/suchen/*",
				]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_serp"),
		}),
		app_serp_map: Object.freeze({
			id: "app_serp_map",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/serp_map/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/classified-map"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_serp_map"),
		}),
		app_serp_project: Object.freeze({
			id: "app_serp_project",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "server",
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/apps/serp_project/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/apps/serp_project/v1/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/:legacyPrimaryLocation/neubauhaeuser.html",
					"/:legacyPrimaryLocation/neubauwohnung.html",
					"/neubauhaeuser.html",
					"/neubauwohnung.html",
					"/project-search",
					"/suchen/:part1/:part2/neubau/*",
				]),
				type: "server",
			}),
			type: "application",
			version: 1,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_serp_project"),
		}),
		app_skpf_seeker: Object.freeze({
			id: "app_skpf_seeker",
			authorization: "authenticated",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/skpf_seeker/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/meinprofil/*"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "minimal",
			testing: Object.freeze([]),
			loader: async () => await import("app_skpf_seeker"),
		}),
		app_ssal_savedSearchManagement: Object.freeze({
			id: "app_ssal_savedSearchManagement",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/ssal_savedSearchManagement/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze(["/nutzerportal/gespeicherte-suchen"]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () => await import("app_ssal_savedSearchManagement"),
		}),
		app_ssal_savedSearchUnsubscribed: Object.freeze({
			id: "app_ssal_savedSearchUnsubscribed",
			authorization: "any",
			microFrontends: Object.freeze({}),
			rendering: "client",
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/apps/ssal_savedSearchUnsubscribed/v2/client/remoteEntry.js",
			}),
			routing: Object.freeze({
				paths: Object.freeze([
					"/nutzerportal/gespeicherte-suche-deaktivieren",
				]),
				type: "server",
			}),
			type: "application",
			version: 2,
			layout: "full",
			testing: Object.freeze([]),
			loader: async () =>
				await import("app_ssal_savedSearchUnsubscribed"),
		}),
	}),
	microFrontends: Object.freeze({
		mfe_avis_adimsxl: Object.freeze({
			id: "mfe_avis_adimsxl",
			type: "micro_frontend",
			rendering: "client",
			version: 1,
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/mfes/avis_adimsxl/v1/client/remoteEntry.js",
			}),
		}),
		mfe_avis_agencyInTheSpotlight: Object.freeze({
			id: "mfe_avis_agencyInTheSpotlight",
			type: "micro_frontend",
			rendering: "client",
			version: 1,
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/mfes/avis_agencyInTheSpotlight/v1/client/remoteEntry.js",
			}),
		}),
		mfe_avis_pricePagesAgencyCards: Object.freeze({
			id: "mfe_avis_pricePagesAgencyCards",
			type: "micro_frontend",
			rendering: "client",
			version: 1,
			urls: Object.freeze({
				client: "https://www.immonet.de/assets/mfes/avis_pricePagesAgencyCards/v1/client/remoteEntry.js",
			}),
		}),
		mfe_esfu_addressEntryPoint: Object.freeze({
			id: "mfe_esfu_addressEntryPoint",
			type: "micro_frontend",
			rendering: "server",
			version: 1,
			urls: Object.freeze({
				server: "https://www.immonet.de/assets/mfes/esfu_addressEntryPoint/v1/server/remoteEntry.js",
				client: "https://www.immonet.de/assets/mfes/esfu_addressEntryPoint/v1/client/remoteEntry.js",
			}),
		}),
	}),
};
